export default __webpack_public_path__ + "images/picture_efficiently-filled-packed-loaded_single-display_v2.webp?b91bfe71750597f5c199d1dbdfcb2cb6";